import React from 'react';
import Input from 'Components/Input';
import Autosuggest from './AutoSuggest';
import { ReactComponent as DeleteIcon } from "Icons/delete.svg";
import { ReactComponent as PlusIcon } from "Icons/new-plus.svg";
import { ReactComponent as CancelIcon } from 'Icons/cancel.svg';
import Dropdown from 'Components/Dropdown';

const ICDDestnToConsignee = (props) => {
	const { containerListTypes, multiModalMovementTypes, trip, tripIndex, onChange, onSelectLocation, locationList, onChangeTrip, onAddSlab, slabs, pricingBasis, onSelectSlab, onChangeSlab, onDeleteTrip, openProviderPopup, onAddTrip, onDeleteTransporter, vehicleTypes, onDeleteSlab } = props;

    return (
        <div>
            <div className='flex flex-between'>
                <Input 
                    type="text" 
                    readOnly={true}
                    value={'Transporter'}
                    className={"theme-color fs-18 fBold wt-250"}
                />
                <div>
					<button className='ph-20 theme-color bg-white fBold br-5 ht-40 fs-16 border-theme mr-20' onClick={() => onAddSlab(tripIndex)}>+ Slab</button>
                    <button className='ph-20 button-bg-color white-color fBold br-5 ht-40 fs-16' onClick={() => openProviderPopup(tripIndex, 2)}>+ Add Provider</button>
                </div>
            </div>
			<div className='mt-10 flex flex-col'>
				<div className='border-light-blue-2 pv-10 ph-10 br-5 wt-95p'>
					<div className='flex flex-between mb-10'>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>From (ICD Destination)</div>
							<Autosuggest
								onChange={(e) => props.onChange(e, tripIndex, 'origin')}
								inputValue={((trip.stops || [])[0] || {}).location}
								onSelect={(option) => onSelectLocation(option,tripIndex, 'origin')}
								options={locationList || []}
								type={`origin_${tripIndex}`}
								displayName={'source'}
                                singleMode={true}
							/>
						</div>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>To</div>
							<Autosuggest
								onChange={(e) => props.onChange(e, tripIndex, 'destination')}
								inputValue={((trip.stops || [])[1] || {}).location}
								onSelect={(option) => onSelectLocation(option, tripIndex, 'destination')}
								options={locationList || []}
								type={`destination_${tripIndex}`}
								displayName={'destination'}
                                singleMode={true}
							/>
						</div>
						<div className='wt-250 fSemibold mr-10'>
							<div className='fs-16 mb-5'>Vehicle Type</div>
							<Dropdown 
								items={vehicleTypes}
								displayKey="name"
								selectedItem={(vehicleTypes || []).find(el => (el.value === (trip.vehicle_details || {}).vehicle_type))}
								name="vehicle_type" 
								label="Select" 
								onSelect={(option) => props.onSelect(option, tripIndex, 'vehicle_type')}
							/>
						</div>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>kms</div>
							<Input 
								value={trip.distance}
								onChange={(e) => onChangeTrip(e, tripIndex, 'distance')}
								disabled={true}
							/>
						</div>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>No. Of Trucks</div>
							<Input 
								value={trip.no_of_trucks}
								onChange={(e) => onChangeTrip(e, tripIndex, 'no_of_trucks')}
							/>
						</div>
					</div>
					<div className='flex flex-between'>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Route Code</div>
							<Input 
								type="text"
								value={trip.route_code}
								onChange={onChangeTrip}
								disabled={true}
							/>
						</div>
						{/* <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Pricing Basis</div>
							<Dropdown 
								items={pricingBasis}
								displayKey="name"
								selectedItem={(pricingBasis || []).find(el => (el.name === trip.pricing_basis_name))}
								name="movement_type" 
								label="Select" 
								onSelect={(option) => props.onSelect(option, tripIndex, 'pricing_basis_name')}
							/>
						</div> */}
						{/* <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Market Rate</div>
							<Input 
								type="number"
								value={trip.market_rate}
								onChange={(e) => onChangeTrip(e, tripIndex, 'market_rate')}
							/>
						</div> */}
                        {/* <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Ceiling Price</div>
							<Input 
								type="number"
								value={(trip['bidding_and_payments'] || {}).qbr}
								onChange={(e) => onChangeTrip(e, tripIndex, 'qbr')}
							/>
						</div> */}
						<div className='wt-250 fSemibold'>
							<div className='fs-16 mb-5'>Internal Remarks</div>
							<Input 
								value={trip.remarks}
								onChange={(e) => onChangeTrip(e, tripIndex, 'remarks')}
							/>
						</div>
					</div>
				</div>
				<div className='ml-10'>
					<div className='mt-40'><DeleteIcon className='wt-25 ht-25 curP' onClick={() => onDeleteTrip(tripIndex)}/></div>
					<div className='mt-40'><PlusIcon className='wt-25 ht-25 curP' onClick={() => onAddTrip()}/></div>
				</div>
			</div>
			{(trip.slabs || []).length > 0 && <div className='border-dashed-bottom-blue border-dashed-left-blue border-dashed-right-blue bg-theme-light pv-10 ph-10 br-5 wt-95p'>
				{(trip.slabs || []).map((slab, slabIndex) => (
				<>
					<div className='flex flex-between'>
						<div className='wt-300 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Description</div>
							<Input 
								value={slab.description}
								onChange={(e) => onChangeSlab(e, tripIndex, slabIndex, 'description')}
							/>
						</div>
						<div className='wt-300 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Slab Wise</div>
							<Dropdown
								items={slabs}
								className={'bg-white'}
								displayKey="name"
								selectedItem={(slabs || []).find(el => (el.name === slab.slab_name))}
								name="movement_type" 
								label="Select" 
								onSelect={(option) => onSelectSlab(option, tripIndex, slabIndex, 'slab_name')}
							/>
						</div>
						<div className='wt-300 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Pricing Basis</div>
							<Dropdown
								items={pricingBasis}
								className={'bg-white'}
								displayKey="name"
								selectedItem={(pricingBasis || []).find(el => (el.value === slab.pricing_basis))}
								name="pricing_basis_name" 
								label="Select" 
								onSelect={(option) => onSelectSlab(option, tripIndex, slabIndex, 'pricing_basis_name')}
							 />
						</div>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>LPP</div>
							<Input disabled={true} value={slab.lpp}/>
						</div>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Market Rate</div>
							<Input  
								value={slab.market_rate}
								onChange={(e) => onChangeSlab(e, tripIndex, slabIndex, 'market_rate')}
							/>
						</div>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Ceiling Price</div>
							<Input 
								type="number"
								value={slab.qbr}
								onChange={(e) => onChangeSlab(e, tripIndex, slabIndex, 'qbr')}
							/>
						</div>
						<div className='wt-50 mr-10 fSemibold'>
							<DeleteIcon className='wt-25 ht-25 mt-20' onClick={() => onDeleteSlab(tripIndex, slabIndex)}/>
						</div>
					</div>
				</>))}
			</div>}
			{(trip.transporters_group || []).length > 0 && <div className='mt-10 border-light-blue-2'>
				<div className={'fs-16 fBold pv-10 ph-10'} style={{'background': '#D4E1FB'}}>Transporters</div>
				{trip.transporters_group.map((transGroup, transGroupIndex) => (
					(transGroup.transporters || []).map((transporter, transporterIndex) => (
						<div className="fs-16 mb-10 inBlock border-bottom-light-2 tCenter mt-10 pv-5 pl-15 pr-15 br-15 ml-20" style={{'background': '#EEF3FD'}}>{transporter.name} <CancelIcon className='ml-5 mr-2 wt-15 ht-10' fill='#EEF3FD' onClick={() => onDeleteTransporter(tripIndex, transGroupIndex, transporterIndex)}/></div>
					))
				))}
			</div>}
        </div>
    )
}

export default ICDDestnToConsignee;